module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-300.38bcfba.woff";